import React, { Component } from 'react'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import CardContent from '@material-ui/core/CardContent';
import Card from '@material-ui/core/Card';
import StyleSheet from 'styles'
import IconButton from '@material-ui/core/IconButton'
import { connect } from 'react-redux'
import { ThirdPartyActions } from 'actionsets'
import { Pagination, ErrorBox } from 'components'
import Typography from '@material-ui/core/Typography'
import Dependent from 'containers/shared/Dependent'
import DeleteIcon from '@material-ui/icons/Delete'
import ViewIcon from '@material-ui/icons/RemoveRedEye'
import EditIcon from '@material-ui/icons/Create'
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'

export class ThirdPartiesList extends Component{

  constructor(props){
    super(props)
    ThirdPartyActions.bindActions(this)
    this.state = { currentPage: 1 }
  }

  dependsOn(){
    return this.actions.index(this.state.currentPage)
  }

  dependenciesMet(){
    return this.props.requests.filter(r => r.type === ThirdPartyActions.INDEX).length === 0
  }

  get totalPages() {
    return this.props.totalPages || 0
  }

  get currentPage() {
    return this.state.currentPage
  }

  set currentPage(value) {
    this.setState({
      currentPage: value
    })
    this.actions.index(value)
  }

  handleShowThirdParty = id => () => {
    this.props.history.push(`/third_parties/${id}`)
  }

  handleEditThirdParty = id => () => {
    this.props.history.push(`/third_parties/${id}/edit`)
  }

  handleDeleteThirdParty = id => async () => {
    await this.actions.destroy({id})
    this.actions.index(this.state.currentPage)
  }

  handleNewThirdParty = () => {
    this.props.history.push(`/third_parties/new`)
  }

  renderThirdParty = ({id, name}) =>
    <ListItem className={styles.listItem} key={id} onClick={this.handleShowThirdParty(id)}>
      <ListItemIcon>
        <FolderSharedIcon/>
      </ListItemIcon>
      <ListItemText className={styles.listItemText} primary={name}/>
      <ListItemSecondaryAction>
        <IconButton aria-label='Delete' onClick={this.handleDeleteThirdParty(id)}>
          <DeleteIcon/>
        </IconButton>
        <IconButton aria-label="view" onClick={this.handleShowThirdParty(id)}>
          <ViewIcon />
        </IconButton>
        <IconButton aria-label="edit" onClick={this.handleEditThirdParty(id)}>
          <EditIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>

  render = () =>
    <div style={{width: '100%'}}>
      <div className={styles.flex}>
        <Card className={styles.card}>
          <CardContent className={styles.content}>
            <Button variant='fab' color='primary' onClick={this.handleNewThirdParty} className={styles.add}>
              <AddIcon />
            </Button>
            <ErrorBox errors={this.props.errors}/>
            <Pagination className={styles.pagination} totalPages={this.totalPages} page={this.currentPage} onPageSelected={(page) => this.currentPage = page}/>
            <div className={styles.listWrapper}>
              <List className={styles.list}>
                {this.props.thirdParties.map(this.renderThirdParty)}
                {!this.props.thirdParties.length && <Typography className={styles.noResultsMessage}>No Third Parties</Typography>}
              </List>
            </div>
            <Pagination className={styles.pagination} totalPages={this.totalPages} page={this.currentPage} onPageSelected={(page) => this.currentPage = page}/>
          </CardContent>
        </Card>
      </div>
    </div>
}

const styles = StyleSheet({
  headline: {
    flex: 1
  },
  errorBox: {
    borderLeft: '4px solid #ad1010',
    padding: 10,
    background: '#f93f3f',
    color: '#d23232',
    margin: 10,
  },
  flex: {
    margin: 10,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    flex: 1,
    '@media(max-width: 500px)': {
      margin: 0
    }
  },
  pagination: {
    padding: 5
  },
  noResultsMessage: {
    margin: 20
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center'
  },
  content: {
    position: 'relative'
  },
  add: {
    position: 'absolute',
    right: -20,
    top: 15
  },
  list: {
    margin: 0,
    paddingTop: 20,
    paddingBottom: 26,
  },
  listWrapper: {
    position: 'relative',
    paddingBottom: 24
  },
  card: {
    maxWidth: 1180,
    flex: 1,
    width: '100%',
    boxSizing: 'border-box'
  },
  listItem: {
    cursor: 'pointer',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.2)'
    }
  },
  '@media(max-width: 600px)': {
    listItemText: {
      cursor: 'pointer',
      '& h6': {
        fontSize: 13
      }
    }
  }
})

export default connect(({thirdParties}) => thirdParties)(Dependent({loader: true, wrapperClassName: styles.wrapper})(ThirdPartiesList))